
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'UploadBox',
  props: {
    text: {
      type: String,
      default: 'Upload file to begin import >>',
    },
    variant: {
      type: String as PropType<'default' | 'bulk'>,
      default: 'default',
    },
  },
  emits: ['onChosen'],
  setup(_props, context) {
    const emitFile = (file: File | undefined) => {
      if (file) {
        context.emit('onChosen', file);
      }
    };

    const chooseFile = () => {
      const input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.setAttribute('accept', '.csv,.xlsx,.xls');
      input.addEventListener('change', (e: Event) => {
        const target = e.target as HTMLInputElement;
        emitFile(target.files?.[0]);
      });
      input.click();
    };

    const onDrop = (e: DragEvent) => {
      emitFile(e.dataTransfer?.files?.[0]);
    };

    return {
      chooseFile,
      onDrop,
    };
  },
});
